@if (open()) {
  <div class="modal-scrim" role="dialog" aria-modal="true" aria-labelledby="captureTitle" (click)="cancel.emit()">
    <div class="modal" (click)="$event.stopPropagation()">
      <div class="modal-head">
        <h2 id="captureTitle">Capture Options</h2>
        <p>We'll attach a screenshot/Video of the page to <b>Pin #{{ markerNumber() }}</b>.</p>
      </div>

      @if (!nativeCaptureAvailable()) {
        <div class="capture-warn" role="status">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>
          <span>Native browser screenshots are not available on this device. You may attempt to capture a screenshot which may not be accurate, or upload one taken manually.</span>
        </div>
      }

      <div class="modal-body">
        <!-- The recommended option: taking the screenshot when the browser can, and
             uploading one when it can't (an attempted one may not be accurate). -->
        <button class="opt" type="button" [class.is-recommended]="nativeCaptureAvailable()" (click)="captureNow.emit()">
          <span class="opt-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
              <circle cx="12" cy="13" r="4" />
            </svg>
          </span>
          <span>
            <span class="opt-title">
              @if (nativeCaptureAvailable()) {
                Take it now <span class="opt-recommended">(Recommended)</span>
              } @else {
                Attempt a screenshot
              }
            </span>
            <span class="opt-sub">{{ nativeCaptureAvailable() ? 'Capture the page exactly as it looks.' : 'May not accurately reflect what you see.' }}</span>
          </span>
          <svg class="opt-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6" /></svg>
        </button>

        @if (nativeCaptureAvailable()) {
          <button class="opt" type="button" (click)="captureDelay.emit()">
            <span class="opt-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="13" r="8" />
                <path d="M12 9v4l2 2M9 2h6" />
              </svg>
            </span>
            <span>
              <span class="opt-title">Wait 3 seconds</span>
              <span class="opt-sub">Time to open a menu, hover an element, or scroll.</span>
            </span>
            <svg class="opt-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6" /></svg>
          </button>
          <button class="opt" type="button" (click)="captureVideo.emit()">
            <span class="opt-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="6" width="14" height="12" rx="2" />
                <path d="m16 10 6-4v12l-6-4z" />
              </svg>
            </span>
            <span>
              <span class="opt-title">Capture Video</span>
              <span class="opt-sub">Capture up to 60 seconds of screen recording while you complete actions.</span>
            </span>
            <svg class="opt-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6" /></svg>
          </button>
        } @else {
          <button class="opt is-recommended" type="button" (click)="uploadScreenshot.emit()">
            <span class="opt-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17 8 12 3 7 8" />
                <line x1="12" y1="3" x2="12" y2="15" />
              </svg>
            </span>
            <span>
              <span class="opt-title">Upload a screenshot <span class="opt-recommended">(Recommended)</span></span>
              <span class="opt-sub">Attach a screenshot you took manually with your device.</span>
            </span>
            <svg class="opt-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6" /></svg>
          </button>
        }
        <button class="opt-skip" type="button" (click)="skipCapture.emit()">Continue without a screenshot</button>
      </div>
      <div class="modal-foot">
        <div class="hint">
          @if (nativeCaptureAvailable()) {
            <kbd>1</kbd> now &nbsp; <kbd>2</kbd> delay &nbsp; <kbd>3</kbd> video &nbsp; <kbd>Esc</kbd> cancel
          } @else {
            <kbd>1</kbd> attempt &nbsp; <kbd>2</kbd> upload &nbsp; <kbd>Esc</kbd> cancel
          }
        </div>
        <button class="btn" type="button" (click)="cancel.emit()">Cancel</button>
      </div>
    </div>
  </div>
}
